import { Type } from 'theme/types';
import styled from "styled-components";
import { Text, Title } from "theme/theme";

export const TextProfile = styled(Title)`
  ${( { theme }: Type ) => theme.profile.text.text }
`

export const TextProfileSecondary = styled(Text)`
  ${( { theme }: Type ) => theme.profile.text.textSecondary }
`

export const TextProfileNav = styled(Text)`
  ${( { theme }: Type ) => theme.profile.text.textNav }
`